"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Label = _interopRequireDefault(require("../Label"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _Link = _interopRequireDefault(require("../../typography/Link"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Input');

var _ref2 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "lock"
});

var _ref3 = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "close"
});

function Input(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onChange = _ref.onChange,
      onCopy = _ref.onCopy,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onEnter = _ref.onEnter,
      id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      autoFocus = _ref.autoFocus,
      value = _ref.value,
      label = _ref.label,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      placeholder = _ref.placeholder,
      hint = _ref.hint,
      error = _ref.error,
      info = _ref.info,
      isRequired = _ref.isRequired,
      isReadOnly = _ref.isReadOnly,
      preComponent = _ref.preComponent,
      postComponent = _ref.postComponent,
      component = _ref.component,
      isCopyable = _ref.isCopyable,
      isBulk = _ref.isBulk,
      bulkEditLabel = _ref.bulkEditLabel,
      bulkCancelLabel = _ref.bulkCancelLabel,
      onBulkEdit = _ref.onBulkEdit,
      onBulkCancel = _ref.onBulkCancel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "onChange", "onCopy", "onFocus", "onBlur", "onEnter", "id", "name", "type", "autoFocus", "value", "label", "labelMode", "isFullWidth", "placeholder", "hint", "error", "info", "isRequired", "isReadOnly", "preComponent", "postComponent", "component", "isCopyable", "isBulk", "bulkEditLabel", "bulkCancelLabel", "onBulkEdit", "onBulkCancel"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // State

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      bulkEditable = _useState4[0],
      setBulkEditable = _useState4[1]; // Overrides


  var override = (0, _overrides.getOverrides)(overridesProp, Input.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isReadOnly, isReadOnly), (0, _defineProperty2.default)(_classnames, classes.isReadAndDuplicable, isCopyable && isReadOnly), (0, _defineProperty2.default)(_classnames, classes[labelMode], labelMode), (0, _defineProperty2.default)(_classnames, classes.isFullWidth, isFullWidth), (0, _defineProperty2.default)(_classnames, classes.focused, focused), (0, _defineProperty2.default)(_classnames, classes.errored, error), (0, _defineProperty2.default)(_classnames, classes.custom, component), (0, _defineProperty2.default)(_classnames, classes.withMessage, (error || info) && !(error && info)), (0, _defineProperty2.default)(_classnames, classes.withTwoMessage, error && info), (0, _defineProperty2.default)(_classnames, classes.withBulk, bulkEditable), (0, _defineProperty2.default)(_classnames, classes.withMessageBulk, (error || info) && !(error && info) && bulkEditable), (0, _defineProperty2.default)(_classnames, classes.withTwoMessageBulk, error && info && bulkEditable), _classnames), classNameProp);
  var rootProps = {
    className: rootClassName
  };
  var labelProps = (0, _extends2.default)({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label);
  var inputProps = (0, _extends2.default)({
    id: id,
    name: name,
    className: classes.input,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: isReadOnly ? undefined : onChange,
    onFocus: (0, _react.useCallback)(function (e) {
      setFocused(true);
      onFocus && onFocus(e);
    }, [onFocus]),
    onBlur: (0, _react.useCallback)(function (e) {
      setFocused(false);
      onBlur && onBlur(e);
    }, [onBlur]),
    onKeyDown: (0, _react.useCallback)(function (e) {
      if (e.key === 'Enter') {
        onEnter && onEnter(e);
      }
    }, [onEnter]),
    autoFocus: autoFocus
  }, override.input);

  if (component) {
    inputProps.isReadOnly = isReadOnly;
  } else {
    inputProps.readOnly = isReadOnly;
  } // Remove content post component


  var postComponentClick = (0, _react.useCallback)(function () {
    onChange && onChange();
    onBlur && onBlur();
  }, [onBlur, onChange]);
  var renderedPostComponent = postComponent;
  var copyValue = (0, _react.useCallback)(function () {
    var textField = document.createElement('textarea');
    textField.innerText = value;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    onCopy && onCopy();
  }, [onCopy, value]);
  var onClickBulkEdit = (0, _react.useCallback)(function () {
    setBulkEditable(true);
    onBulkEdit && onBulkEdit();
  }, [onBulkEdit]);
  var onClickBulkCancel = (0, _react.useCallback)(function () {
    setBulkEditable(false);
    onBulkCancel && onBulkCancel();
  }, [onBulkCancel]);
  var compIsReadOnly = _ref2;

  var compIsCopyable = /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "duplicate",
    onClick: copyValue
  });

  if (value && !isReadOnly) {
    renderedPostComponent = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      onClick: postComponentClick,
      className: "".concat(classes.postCloseComponent, " ").concat(classes.isClickable, " ").concat(classes.clear)
    }, _ref3), postComponent);
  }

  if (isReadOnly) {
    renderedPostComponent = /*#__PURE__*/_react.default.createElement("span", {
      className: classes.postCloseComponent
    }, compIsReadOnly);
  }

  if (isCopyable) {
    renderedPostComponent = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(classes.postCloseComponent)
    }, compIsCopyable), postComponent);
  }

  if (isReadOnly && isCopyable) {
    renderedPostComponent = /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(classes.postCloseComponent)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(classes.isClickable, " ").concat(classes.copy)
    }, compIsCopyable), compIsReadOnly);
  }

  var Component = component;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), label && /*#__PURE__*/_react.default.createElement(_Label.default, labelProps, label), isBulk && !bulkEditable && /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: classes.bulkEdit,
    onClick: onClickBulkEdit
  }, bulkEditLabel), (!isBulk || isBulk && bulkEditable) && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.formControl
  }, override.formControl), preComponent && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.preComponent
  }, override.postComponent), preComponent), !component && /*#__PURE__*/_react.default.createElement("input", inputProps), component && /*#__PURE__*/_react.default.createElement(Component, inputProps), renderedPostComponent && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.postComponent
  }, override.postComponent), renderedPostComponent), info && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.info
  }, override.info), info), error && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes.error
  }, override.error), error), bulkEditable && /*#__PURE__*/_react.default.createElement(_Link.default, {
    className: classes.bulkCancel,
    onClick: onClickBulkCancel
  }, bulkCancelLabel)));
}

Input.overrides = ['root', 'input', 'error', 'info', 'preComponent', 'postComponent', 'formControl', 'Label'];
Input.defaultProps = {
  labelMode: 'horizontal',
  type: 'text',
  onChange: function onChange() {},
  value: '',
  isReadOnly: false,
  isCopyable: false,
  override: {}
};
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onEnter: _propTypes.default.func,

  /** Native input id */
  id: _propTypes.default.string,

  /** Native input name */
  name: _propTypes.default.string,

  /** Native input type */
  type: _propTypes.default.string,
  value: _propTypes.default.any,
  label: _propTypes.default.string,
  labelMode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  placeholder: _propTypes.default.string,
  isFullWidth: _propTypes.default.bool,

  /** Info popover */
  hint: _propTypes.default.string,

  /** Error will be displayed below the component with style changes */
  error: _propTypes.default.string,
  onCopy: _propTypes.default.func,

  /** Info will be displayed below the component with style changes */
  info: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  isCopyable: _propTypes.default.bool,

  /** Component rendered at the input beginning */
  preComponent: _propTypes.default.any,

  /** Component rendered at the input ending */
  postComponent: _propTypes.default.any,

  /** Custom input component */
  component: _propTypes.default.any
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Input);

exports.default = _default;